// https://vike.dev/onCreateApp
export { onCreateApp }

import type { OnCreateAppSync } from 'vike-vue'
import { setAppInstance } from './appInstance'

import '@/assets/css/app-invoice.min.css'
import '@/assets/css/invoice.css'
import '@/assets/css/components.css'
import '@/assets/css/colors.css'
import '@/assets/css/style2.css'
import '@/assets/css/line-icons.css'
import '@/assets/css/magnific-popup.css'
import '@/assets/css/nivo-lightbox.css'
import '@/assets/css/main.css'
import '@/assets/css/responsive.css'
import '@/assets/css/shepherd.min.css'
import '@/assets/css/ext-component-tour.min.css'

import "bootstrap/dist/css/bootstrap.min.css"
import '@/style.css'

if (typeof window !== 'undefined') {
    import("bootstrap")
}

import '@/assets/css/style.css'
import 'vue-loaders/dist/vue-loaders.css';
import '@trevoreyre/autocomplete-vue/dist/style.css'
import 'vue-loading-overlay/dist/css/index.css'
import 'animate.css';

import VueLoaders from "vue-loaders";
import VueSmoothScroll from "vue3-smooth-scroll";
import VueEasyLightbox from "vue-easy-lightbox";
import { LoadingPlugin } from "vue-loading-overlay";
import FontAwesomeIcon from "@/utils/fontawesome.ts";
import VOtpInput from "vue3-otp-input";
import animateScroll from "@/utils/directives/animateScroll.ts";

const ArrowUp = defineAsyncComponent(() => import('vue-material-design-icons/ArrowUp.vue'))
const ArrowDown = defineAsyncComponent(() => import('vue-material-design-icons/ArrowDown.vue'))

// @ts-ignore
import Autocomplete from '@trevoreyre/autocomplete-vue'

// @ts-ignore
import VueProgressBar from "@aacassandra/vue3-progressbar"

// @ts-ignore
import * as Sentry from '@sentry/vue'

import { createHead } from "@vueuse/head"
import { defineAsyncComponent } from 'vue'
const head = createHead()

const onCreateApp: OnCreateAppSync = (pageContext): ReturnType<OnCreateAppSync> => {
    const { app } = pageContext

    const progressOptions = {
        color: "#FEB23C",
        failedColor: "#874b4b",
        thickness: "3px",
        transition: {
            speed: "0.2s",
            opacity: "0.6s",
            termination: 300,
        },
        autoRevert: true,
        location: "top",
        inverse: false,
    };

    // @ts-ignore
    // app.use(i18n)
    // @ts-ignore
    //   app.use(VueAnimateOnScroll)
    app.use(VueProgressBar, progressOptions)
    app.use(VueLoaders);
    app.use(VueSmoothScroll)

    // NOT NECESSARY SINCE, WE'RE USING GOOGLE TAG MANAGER
    // const ga_tag = import.meta.env.VITE_GOOGLE_ANALYTICS_TAG
    // app.use(VueGtag, {
    //     config: { id: ga_tag },
    //     deferScriptLoad: true
    // })

    app.use(VueEasyLightbox)
    app.use(LoadingPlugin)

    app.use(head)

    const isDevMode = import.meta.env.DEV

    if (!isDevMode && typeof window !== 'undefined') {
        try {
            Sentry.init({
                app,
                dsn: import.meta.env.VITE_SENTRY_DSN,
                integrations: [
                    Sentry.browserTracingIntegration(),
                    Sentry.replayIntegration(),
                ],
                beforeSend(event, hint) {
                    if (hint && hint.originalException instanceof Error) {
                        return event; // Capture and send errors
                    }
                    return null; // Ignore non-error events
                },
                tracingOptions: {
                    trackComponents: true,
                },
                tracesSampleRate: 1.0,
                replaysSessionSampleRate: 0.1,
                replaysOnErrorSampleRate: 1.0,
            });
        } catch (e) {
            console.log('Error initializing Sentry', e)
        }
    }

    app.component('font-awesome-icon', FontAwesomeIcon)
    app.component('autocomplete', Autocomplete)
    app.component('v-otp-input', VOtpInput)
    app.component('arrow-up', ArrowUp)
    app.component('arrow-down', ArrowDown)
    
    app.directive('animate-scroll', animateScroll)

    // @ts-ignore
    app.config.productionTip = false

    setAppInstance(app)
}
